import request from '@/utilsCloud/request'
import port from './port'

// 获取公共课程库列表菜单
export function exerciseRecordResult(query) {
  return request({
    url: port.exam + '/exercise/exerciseRecordResult',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/apiCloud/otherTestRerult.js